import { render } from "./StudentsList.vue?vue&type=template&id=6300f1f6&scoped=true"
import script from "./StudentsList.vue?vue&type=script&lang=js"
export * from "./StudentsList.vue?vue&type=script&lang=js"

import "./StudentsList.vue?vue&type=style&index=0&id=6300f1f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6300f1f6"]])

export default __exports__